/*eslint-disable*/

// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.


const Formstyle = ((($) => {
  // try to declare variables that are going to be used to improve performance
  let someDivElement;

  // in this function you get all the div elements that need to be manipulated
  function init() {
    someDivElement = $('input[type="checkbox"], input[type="radio"]');
    someDivElement.styler();
  }

  return {
    init,
  };
}))(jQuery);

// don't forget to export
export default Formstyle;



// WEBPACK FOOTER //
// ./src/static/js/modules/formstyle.js